import React, { useEffect } from 'react';
import { updateSocialMeta } from '../utils/seo';

const COURSES_PAGE_1 = [
  { course: 'Tall Pines Golf Club', location: 'Friendsville, PA', yardage: '7,005', par: '72', difficulty: 'Very Hard' },
  { course: 'Muirfield Village Golf Club', location: 'Columbus, OH', yardage: '7,516', par: '72', difficulty: 'Very Hard' },
  { course: 'Pinehurst No. 2', location: 'Pinehurst, NC', yardage: '7,588', par: '70', difficulty: 'Very Hard' },
  { course: 'Pebble Beach Golf Links', location: 'Pebble Beach, CA', yardage: '7,075', par: '72', difficulty: 'Very Hard' },
  { course: 'Harbour Town Golf Links', location: 'Hilton Head Island, SC', yardage: '7,099', par: '71', difficulty: 'Very Hard' },
  { course: 'Teton Pines', location: 'Jackson, WY', yardage: '7,382', par: '72', difficulty: 'Very Hard' },
  { course: 'St Andrews Old Course', location: 'St. Andrews, Scotland', yardage: '7,287', par: '72', difficulty: 'Very Hard' },
  { course: 'Spyglass Hill', location: 'Pebble Beach, CA', yardage: '7,025', par: '72', difficulty: 'Very Hard' },
  { course: 'Wellington National Golf Club', location: 'Wellington, FL', yardage: '7,125', par: '72', difficulty: 'Very Hard' },
  { course: 'Butterfield Country Club (Blue/Red)', location: 'Oak Brook, IL', yardage: '6,890', par: '71', difficulty: 'Very Hard' },
  { course: 'Broken Tree Golf Course', location: 'Fantasy', yardage: '7,143', par: '72', difficulty: 'Very Hard' },
  { course: 'Kinsale Golf & Fitness Club', location: 'Powell, OH', yardage: '7,228', par: '72', difficulty: 'Hard' },
  { course: 'Blue Bayou', location: 'Fantasy', yardage: '6,111', par: '68', difficulty: 'Hard' },
  { course: 'The Bedens Brook Club', location: 'Skillman, NJ', yardage: '6,964', par: '72', difficulty: 'Hard' },
  { course: 'The Farms Golf Club', location: 'Rancho Santa Fe, CA', yardage: '6,953', par: '72', difficulty: 'Hard' },
  { course: 'The Links at Spanish Bay', location: 'Pebble Beach, CA', yardage: '6,726', par: '72', difficulty: 'Hard' },
  { course: 'Awbrey Glen Golf Course', location: 'Bend, OR', yardage: '7,019', par: '72', difficulty: 'Hard' },
  { course: 'Tara Iti Golf Club', location: 'Bradenton, FL', yardage: '6,928', par: '71', difficulty: 'Hard' },
  { course: 'Greencastle Golf Club', location: 'Greencastle, PA', yardage: '6,811', par: '72', difficulty: 'Hard' },
  { course: 'St Andrews Castle Course', location: 'St. Andrews, Scotland', yardage: '6,759', par: '71', difficulty: 'Hard' },
  { course: 'Prairie Bluff Golf Club', location: 'Crest Hill, IL', yardage: '7,007', par: '72', difficulty: 'Hard' },
];

const COURSES_PAGE_2 = [
  { course: 'Beaver Hills Country Club', location: 'Cedar Falls, IA', yardage: '6,848', par: '72', difficulty: 'Moderate' },
  { course: 'Sunnyside Golf & Country Club', location: 'Fresno, CA', yardage: '6,756', par: '72', difficulty: 'Moderate' },
  { course: 'St Andrews Jubilee Course', location: 'St. Andrews, Scotland', yardage: '6,742', par: '72', difficulty: 'Moderate' },
  { course: 'Glen Flora Country Club', location: 'Waukegan, IL', yardage: '6,602', par: '70', difficulty: 'Moderate' },
  { course: 'St Andrews New Course', location: 'St. Andrews, Scotland', yardage: '6,625', par: '71', difficulty: 'Moderate' },
  { course: 'Black Rock Golf Course', location: 'Hagerstown, MC', yardage: '6,675', par: '72', difficulty: 'Moderate' },
  { course: 'Meadowbrook Country Club', location: 'Northville, MI', yardage: '6,419', par: '71', difficulty: 'Moderate' },
  { course: 'Willow Crest Golf Club', location: 'Oak Brook, IL', yardage: '6,494', par: '70', difficulty: 'Moderate' },
  { course: 'Twin Run Golf Course', location: 'Hamilton, OH', yardage: '6,515', par: '72', difficulty: 'Moderate' },
  { course: 'Detroit Country Club (Pine to Palm)', location: 'Detroit Lakes, MN', yardage: '6,106', par: '71', difficulty: 'Easy' },
  { course: 'Mill Creek Golf Club', location: 'Geneva, IL', yardage: '6,310', par: '72', difficulty: 'Easy' },
  { course: 'Linfield National Golf Club', location: 'Linfield, PA', yardage: '6,060', par: '71', difficulty: 'Easy' },
  { course: "Potter's Park Golf Course", location: 'Hamilton, OH', yardage: '5,354', par: '69', difficulty: 'Easy' },
  { course: 'Tropical Paradise Executive', location: 'Fantasy', yardage: '2,778', par: '54', difficulty: 'Easy' },
  { course: 'Barren Boulders Executive', location: 'Fantasy', yardage: '3,094', par: '56', difficulty: 'Easy' },
  { course: 'Pinehurst (The Cradle) 9 holes', location: 'Pinehurst, NC', yardage: '1,578', par: '54', difficulty: 'Very Easy' },
];

const COURSES_ALL = [...COURSES_PAGE_1, ...COURSES_PAGE_2];

const Courses = () => {
  useEffect(() => {
    document.title = 'Golf Course List - Pin High Golf & Lounge | Courses';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Browse Pin High Golf & Lounge golf courses in a grid (Course, Location, Yardage, Par, Difficulty).'
      );
    }

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://pinhighbay.com/courses');
    updateSocialMeta({
      title: 'Golf Course List - Pin High Golf & Lounge | Courses',
      description: 'Browse Pin High Golf & Lounge golf courses in a grid (Course, Location, Yardage, Par, Difficulty).',
      path: '/courses',
    });
  }, []);

  const renderCoursesTable = (rows) => (
    <div className="overflow-x-auto">
      <table className="min-w-[820px] w-full table-fixed text-left font-mono text-sm">
        <colgroup>
          <col style={{ width: '40%' }} />
          <col style={{ width: '28%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '6%' }} />
          <col style={{ width: '16%' }} />
        </colgroup>
        <tbody>
          {rows.map((r) => (
            <tr key={`${r.course}-${r.location}-${r.yardage}`}>
              <td className="pr-3 py-0.5 whitespace-nowrap overflow-hidden text-ellipsis">{r.course}</td>
              <td className="pr-3 py-0.5 whitespace-nowrap overflow-hidden text-ellipsis">{r.location}</td>
              <td className="pr-3 py-0.5 whitespace-nowrap text-right">{r.yardage}</td>
              <td className="pr-3 py-0.5 whitespace-nowrap text-right">{r.par}</td>
              <td className="py-0.5 whitespace-nowrap overflow-hidden text-ellipsis">{r.difficulty}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="min-h-screen bg-white">
      <section className="bg-gradient-to-br from-green-600 to-green-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-3">Golf Course List</h1>
          <p className="text-green-50 text-lg md:text-xl max-w-3xl mx-auto">
            Rendered in a grid matching the course list PDF columns.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-mono text-sm">
            <div className="text-center font-bold mb-3">Golf Course List</div>
            {renderCoursesTable(COURSES_ALL)}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Courses;

